import { useEffect, useRef, useState } from "react";
import { Play, Pause, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

const fmt = (s) => `0:${String(Math.floor(s || 0)).padStart(2, "0")}`;

export default function SamplePlayer({ bookId, voice, label, active, onPlay }) {
  const audio = useRef(null);
  const [state, setState] = useState("idle");
  const [time, setTime] = useState({ cur: 0, dur: 0 });

  useEffect(() => {
    if (!active && audio.current && !audio.current.paused) audio.current.pause();
  }, [active]);

  const toggle = () => {
    const el = audio.current;
    if (el.paused) {
      onPlay(`${bookId}-${voice}`);
      setState("loading");
      el.play().catch(() => setState("error"));
    } else el.pause();
  };

  const pct = time.dur ? (time.cur / time.dur) * 100 : 0;
  return (
    <div className="border border-white/10 bg-[#121212]/90 p-5 flex items-center gap-5 hover:border-primary-gold/40 transition-colors" data-testid={`sample-${bookId}-player-${voice}`}>
      <audio
        ref={audio}
        src={`${API}/samples/${bookId}/audio/${voice}`}
        preload="none"
        onPlaying={() => setState("playing")}
        onPause={() => setState("idle")}
        onEnded={() => setState("idle")}
        onError={() => setState("error")}
        onTimeUpdate={(e) => setTime({ cur: e.target.currentTime, dur: e.target.duration })}
      />
      <button onClick={toggle} data-testid={`sample-${bookId}-play-${voice}`} aria-label={`Play ${label} sample`}
        className="w-14 h-14 shrink-0 rounded-full bg-primary-gold text-black flex items-center justify-center hover:scale-105 transition-transform">
        {state === "loading" ? <Loader2 className="w-5 h-5 animate-spin" /> : state === "playing" ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
      <div className="flex-1 min-w-0">
        <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-primary-gold">{label}</p>
        <div className="mt-3 h-1 bg-white/10"><div className="h-1 bg-primary-gold transition-[width] duration-300" style={{ width: `${pct}%` }} data-testid={`sample-${bookId}-progress-${voice}`} /></div>
        <p className="mt-2 font-mono-ui text-[11px] text-soft">
          {state === "error" ? <span data-testid={`sample-${bookId}-error-${voice}`}>Couldn't load the sample — please try again.</span> : `${fmt(time.cur)} / ${time.dur ? fmt(time.dur) : "0:30"}`}
        </p>
      </div>
    </div>
  );
}
